import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CATEGORY_LABELS = {
  damaged_package: 'Colis endommagé',
  recipient_absent: 'Destinataire absent',
  wrong_address: 'Adresse erronée',
  refused_by_recipient: 'Refusé par le destinataire',
  missing_package: 'Colis manquant',
  customs_issue: 'Problème de douane',
  other: 'Autre',
};

const STATUS_LABELS = {
  open: 'Ouvert',
  acknowledged: 'Pris en compte',
  resolved: 'Résolu',
  closed: 'Clôturé',
};

const IncidentPublicView = () => {
  const { token } = useParams();
  const [incident, setIncident] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [zoom, setZoom] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/incidents/view/${token}`);
        setIncident(res.data);
      } catch {
        setError("Incident introuvable ou lien expiré.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  const photoSrc = (url) => (url?.startsWith('http') ? url : `${BACKEND_URL}${url}`);

  return (
    <div className="min-h-screen bg-[#e9eae6] text-[#17130f] flex flex-col items-center py-10 px-4">
      <div className="w-full max-w-2xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="text-2xl">⚠️</span>
          <h1 className="text-xl font-bold">Signalement d'incident</h1>
        </div>

        {loading && <p className="text-sm text-[#17130f]/60">Chargement…</p>}
        {error && (
          <div className="bg-white rounded-xl p-6 shadow-sm border border-[#dc5a12]/20">
            <p className="text-sm text-[#dc5a12]">{error}</p>
          </div>
        )}

        {incident && (
          <div className="bg-white rounded-xl p-6 shadow-sm space-y-5">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold bg-[#dc5a12]/10 text-[#dc5a12]">
                {CATEGORY_LABELS[incident.category] || incident.category}
              </span>
              {incident.status && (
                <span className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold bg-[#17130f]/5 text-[#17130f]/70">
                  {STATUS_LABELS[incident.status] || incident.status}
                </span>
              )}
            </div>

            {(incident.package_oce_code || incident.shipment_name) && (
              <div className="text-sm">
                {incident.package_oce_code && (
                  <p><span className="text-[#17130f]/60">Colis :</span> <strong>{incident.package_oce_code}</strong></p>
                )}
                {incident.shipment_name && (
                  <p><span className="text-[#17130f]/60">Départ :</span> <strong>{incident.shipment_name}</strong></p>
                )}
              </div>
            )}

            <div>
              <p className="text-xs uppercase tracking-wide text-[#17130f]/50 mb-1">Description</p>
              <p className="text-sm whitespace-pre-wrap">{incident.description}</p>
            </div>

            {incident.photos && incident.photos.length > 0 && (
              <div>
                <p className="text-xs uppercase tracking-wide text-[#17130f]/50 mb-2">
                  Photos ({incident.photos.length})
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                  {incident.photos.map((url, i) => (
                    <button
                      key={i}
                      type="button"
                      onClick={() => setZoom(photoSrc(url))}
                      className="block aspect-square overflow-hidden rounded-lg border border-[#17130f]/10"
                    >
                      <img src={photoSrc(url)} alt={`Photo ${i + 1}`} className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              </div>
            )}

            <p className="text-xs text-[#17130f]/40 pt-2 border-t border-[#17130f]/10">
              Message automatique — merci de ne pas répondre.
            </p>
          </div>
        )}
      </div>

      {zoom && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50"
          onClick={() => setZoom(null)}
        >
          <img src={zoom} alt="Photo" className="max-w-full max-h-full rounded-lg" />
        </div>
      )}
    </div>
  );
};

export default IncidentPublicView;
